import { render, staticRenderFns } from "./PumpTwoColumnTable.vue?vue&type=template&id=4fb7d8d6&scoped=true"
import script from "./PumpTwoColumnTable.vue?vue&type=script&lang=js"
export * from "./PumpTwoColumnTable.vue?vue&type=script&lang=js"
import style0 from "./PumpTwoColumnTable.vue?vue&type=style&index=0&id=4fb7d8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7d8d6",
  null
  
)

export default component.exports